import { createFileRoute } from "@tanstack/react-router";

import { PageHero, PolicyBody } from "@/components/site/Page";
import { CookiePolicyContent } from "@/components/site/PolicyCookieSection";
import { getCookiePolicyContent } from "@/lib/cookie-policy.functions";
import { absoluteUrl, ogImage, seoLinks } from "@/lib/seo";

const title = "Cookiepolicy | Swedish International School";
const description =
  "Vilka cookies och vilken lagring sweintschool.com använder, varför, hur länge och hur du ändrar ditt val.";

export const Route = createFileRoute("/cookiepolicy")({
  loader: () => getCookiePolicyContent({ data: { locale: "sv" } }),
  errorComponent: () => <PolicyLoadError message="Cookiepolicyn kunde inte laddas." />,
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl("/cookiepolicy") },
      { name: "twitter:card", content: "summary" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks("/cookiepolicy"),
  }),
  component: CookiePolicyPage,
});

function CookiePolicyPage() {
  const policy = Route.useLoaderData();
  return (
    <>
      <PageHero eyebrow="Integritet" title="Cookiepolicy" intro="Vilka cookies vi använder, varför och hur du ändrar ditt val." />
      <PolicyBody>
        <CookiePolicyContent locale="sv" body={policy.body} />
      </PolicyBody>
    </>
  );
}

function PolicyLoadError({ message }: { message: string }) {
  return <main className="mx-auto max-w-3xl px-4 py-24"><p role="alert">{message}</p></main>;
}
